/**
 * Get the appropriate portal/dashboard path based on user role
 * @param {string} role - User role (student, librarian, admin, etc.)
 * @returns {string} - The path to redirect to
 */
export function getPortalPath(role) {
  switch (role?.toLowerCase()) {
    case 'student':
      return '/student';
    case 'librarian':
      return '/librarian';
    case 'admin':
      return '/admin-dashboard';
    case 'institute_manager':
      return '/institute-manager-dashboard';
    case 'marketing':
      return '/marketing-dashboard';
    case 'sales':
      return '/sales-dashboard';
    case 'seo':
      return '/seo-dashboard';
    default:
      return '/student'; // Default to student portal
  }
}

/**
 * Check if user has access to a specific portal
 * @param {string} userRole - User's role
 * @param {string} requiredRole - Required role for access
 * @returns {boolean} - Whether user has access
 */
export function hasPortalAccess(userRole, requiredRole) {
  return userRole?.toLowerCase() === requiredRole?.toLowerCase();
}

/**
 * Check if user is authenticated and has correct role, redirect if not
 * @param {object} user - User object from AuthContext
 * @param {string} requiredRole - Required role for the portal
 * @param {function} navigate - React Router navigate function
 * @returns {boolean} - Whether user has access (true) or was redirected (false)
 */
export function checkPortalAccess(user, requiredRole, navigate) {
  if (!user) {
    // Not authenticated - redirect to login
    navigate('/login');
    return false;
  }

  if (!hasPortalAccess(user.role, requiredRole)) {
    // Wrong role - redirect to their correct portal
    navigate(getPortalPath(user.role));
    return false;
  }

  return true;
}
